import { render, staticRenderFns } from "./frgzb.vue?vue&type=template&id=343a841a&scoped=true&"
import script from "./frgzb.vue?vue&type=script&lang=js&"
export * from "./frgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a841a",
  null
  
)

export default component.exports